import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const DesktopLayout = styled.div `
  display: flex;
  height: 100%;
`;
export const SidebarPanel = styled.div `
  width: ${pxToRem(300)};
  border-right: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
`;
export const ContentPanel = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;
export const PanelBody = styled.div `
  flex: 1;
  overflow: auto;
  padding: ${themeGet('spacing.2xl')};
`;
export const PanelFooter = styled.div `
  flex-shrink: 0;
  padding: ${themeGet('spacing.2xl')};
  border-top: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
